import { CHANNEL_LAYOUT_VALUES } from './channel-layout-values';

const ON_MOUSE_OVER = 1;
const ALWAYS = 2;
const NEVER = 3;

export const CLASSIC_SHOW_INFO_VALUES = [
  ON_MOUSE_OVER,
  ALWAYS,
];

export const STRIP_SHOW_INFO_VALUES = [
  ...CLASSIC_SHOW_INFO_VALUES,
  NEVER,
];

export const COMPACT_SHOW_INFO_VALUES = [
  ...STRIP_SHOW_INFO_VALUES,
];

export const SHOW_INFO_VALUES = {
  ON_MOUSE_OVER,
  ALWAYS,
  NEVER,
};

export const PER_LAYOUT_SHOW_INFO_VALUES = {
  [CHANNEL_LAYOUT_VALUES.CLASSIC]: CLASSIC_SHOW_INFO_VALUES,
  [CHANNEL_LAYOUT_VALUES.STRIP]: STRIP_SHOW_INFO_VALUES,
  [CHANNEL_LAYOUT_VALUES.COMPACT]: COMPACT_SHOW_INFO_VALUES,
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/show-info-values.js